import React from 'react'
import classes from './Footer.module.css'
function Footer() {
  return (
    <footer>
      <div className={classes.wrapper}>
        <p>For internal use only.</p>  
      </div>
    </footer>
  );
}

export default Footer;